const ImageSkeleton = ({ className = '' }) => {
    return (
        <div
            className={`animate-pulse bg-[#E2E8F0] rounded-[20px] ${className}`}
        />
    )
}

export default ImageSkeleton
